/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedSingleTurnChatDataset
 */
export interface PerturbedSingleTurnChatDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedSingleTurnChatDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedSingleTurnChatDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedSingleTurnChatDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedSingleTurnChatDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedSingleTurnChatDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof PerturbedSingleTurnChatDataset
   */
  language: SingleTurnChatLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedSingleTurnChatDataset interface.
 */
export function instanceOfPerturbedSingleTurnChatDataset(value: object): value is PerturbedSingleTurnChatDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedSingleTurnChatDatasetFromJSON(json: any): PerturbedSingleTurnChatDataset {
  return PerturbedSingleTurnChatDatasetFromJSONTyped(json, false);
}

export function PerturbedSingleTurnChatDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedSingleTurnChatDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedSingleTurnChatDatasetToJSON(
  value?: Omit<PerturbedSingleTurnChatDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
  };
}
